import { ReactNode, useEffect } from "react";
import { Spin } from "antd";
import { env } from "@shared/config.ts";
import { useRedirect, useAuth, useCountdown } from "@shared/lib/hooks";
import "./private-check.scss";

const isInIframe = window.parent !== window;

export const PrivateCheck = ({ children }: { children: ReactNode }) => {
  const { isProcessing, isError } = useAuth();
  const redirect = useRedirect();
  const { startCount, isEnded, count } = useCountdown();

  useEffect(() => {
    if (isEnded && !isInIframe) {
      redirect(
        `${env.OLD_FRONTEND_URL}/sign-in?redirectTo=${env.FRONTEND_URL}`,
      );
    }
  }, [isEnded, redirect]);

  useEffect(() => {
    if (isError && !isInIframe) {
      startCount(3);
    }
  }, [isError, startCount]);

  const handleManualRedirect = () => {
    redirect(`${env.OLD_FRONTEND_URL}/sign-in&redirectTo=${env.FRONTEND_URL}`);
  };

  if (isProcessing || (isError && isInIframe)) {
    return (
      <div className="private-check-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="private-check-error">
        <p>
          Ошибка авторизации. Вы будете перенаправлены на страницу авторизации
          через {count}
        </p>
        <p>
          <span
            className="private-check-error__link"
            onClick={handleManualRedirect}
          >
            Перейти вручную
          </span>
        </p>
      </div>
    );
  }

  return <>{children}</>;
};
